import createReducer from 'utils/createReducer';

const INIT_STATE = {
  form: {
    country: null,
    zipcode: '',
    locality: '',
    address: null,
    venue: null,
    addressInputValue: '',
    venueInputValue: '',
  },

  localityGID: null,
};

const SET_FORM_VALUE = 'point-of-interest/searcher/SET_FORM_VALUE';
const SET_LOCALITY_GID = 'point-of-interest/searcher/SET_LOCALITY_GID';
const SET_RESET = 'point-of-interest/searcher/SET_RESET';
const SET_CLEAR_FORM_VALUES = 'point-of-interest/searcher/SET_CLEAR_FORM_VALUES';

const reducer = createReducer(INIT_STATE, {
  [SET_FORM_VALUE](state, payload) {
    return {
      ...state,
      form: {
        ...state.form,
        [payload.field]: payload.value,
      },
    };
  },
  [SET_RESET]() {
    return INIT_STATE;
  },
  [SET_LOCALITY_GID](state, payload) {
    return {
      ...state,
      localityGID: payload.localityGID,
    };
  },
  [SET_CLEAR_FORM_VALUES](state, payload) {
    return {
      ...state,
      form: {
        ...state.form,
        ...payload.formVales.reduce(
          (acc, key) => ({
            ...acc,
            [key]: INIT_STATE.form[key],
          }),
          {}
        ),
      },
    };
  },
});

const setFormValue = (field, value) => ({
  type: SET_FORM_VALUE,
  payload: { field, value },
});

const setReset = () => ({
  type: SET_RESET,
  payload: {},
});

const setLocalityGID = (localityGID) => ({
  type: SET_LOCALITY_GID,
  payload: { localityGID },
});

const setClearFormValues = (formVales) => ({
  type: SET_CLEAR_FORM_VALUES,
  payload: { formVales },
});

export default reducer;
export { INIT_STATE, setFormValue, setReset, setLocalityGID, setClearFormValues };
